<template>
  <div id="algorithmDetail">
    <div>
      <nav-bar @searchInfo="redrectSearchInfo"></nav-bar>
    </div>
    <div class="content">
      <breadcrumb-guid ref="breadcrumbGuidContainer"></breadcrumb-guid>
      <!-- <div class="widthStyle tableBox"> -->

      <div ref="tableBox" class="tableBox" :class="isDefaultType ? 'widthStyle' : 'widthStyle-w80'">
        <div class="displayWindow" v-show="activeName == 'one'">
          <div class="displayWindow-left">
            <!-- <pic-zoom v-if="baseinfo.defaultpic" :url="imgSrc" :scale="3"></pic-zoom> -->
            <div class="imgBox">
              <pic-zoom style="width:100%" v-if="baseinfo.defaultpic" :url="imgSrc" :scale="3"
                @click.native="showBigPicture"></pic-zoom>
              <!-- <img v-if="baseinfo.defaultpic" :src="imgSrc" alt="" /> -->
              <img v-else src="@/assets/images/shebei1.png" width="100%" height="100%" />
            </div>
            <!-- 轮播swiper -->
            <div class="swiperContent">
              <div class="leftIcon" @click="handleLeft"><i class="iconfont icon-left"></i></div>
              <div class="swiper-container swiper1">
                <!--  v-if="true" -->
                <div class="swiper-wrapper">
                  <div class="swiper-slide" v-for="item in baseinfo.picarray">
                    <img v-if="item.path" :src="$store.state.defaultPicUrl + item.path + item.ftpName" />
                    <img v-else src="@/assets/images/shebei1.png" />
                    <!-- <img  src="@/assets/images/shebei1.png" /> -->
                  </div>
                </div>
              </div>
              <div class="rightIcon" @click="handleRight"><i class="iconfont icon-you"></i></div>
            </div>

            <div class="left-bottom flexRow flexRowBetween">
              <div>
                <div class="mar10 hoverClass" @click="saveLogsGoodsCollection()">
                  <i class="iconfont icon-guanzhu" style="vertical-align: baseline;color: red;"></i>
                  <span :class="baseinfo.logsGoodsCollectionId ? 'guanzhu' : 'color1'"
                    v-show="baseinfo.logsGoodsCollectionId">取消关注</span>
                  <span class="color1" v-show="!baseinfo.logsGoodsCollectionId">关注</span>
                  <span style="color: #F6807D;">{{ baseinfo.logsGoodsCollectionCount }}</span>
                </div>
                <div class="mar10 hoverClass" @click="saveLogsGoodsShare()">
                  <i class="iconfont icon-fenxiang" style="vertical-align: bottom;color: red;"></i>
                  <span :class="baseinfo.logsGoodsShareCount ? 'guanzhu' : 'color1'">分享</span>
                  <span style="color: #F6807D;">{{ baseinfo.logsGoodsShareCount }}</span>
                </div>
              </div>
              <div>
                <div class="mar10 flexRow">
                  <div class="hoverClass" style="margin-right: 5px;" @click="saveLogsGoodsPraise('up')">
                    <i class="iconfont icon-dianzan" style="vertical-align: baseline;color: red;"></i>
                    <span :class="baseinfo.praiseType == 'up' ? 'guanzhu' : 'color1'">顶</span>
                    <span style="color: #F6807D;">{{ baseinfo.logsGoodsPraiseUpCount }}</span>
                  </div>
                  <div class="hoverClass" @click="saveLogsGoodsPraise('down')">
                    <i class="iconfont icon-fandui" style="vertical-align: baseline;color: #666;"></i>
                    <span :class="baseinfo.praiseType == 'down' ? 'guanzhu' : 'color1'">踩</span>
                    <span style="color: #F6807D;">{{ baseinfo.logsGoodsPraiseDownCount }}</span>
                  </div>
                </div>
                <div class="mar10">
                  <el-rate v-model="rateValue" @change="handleRateSelect"></el-rate>
                </div>
              </div>
            </div>
          </div>

          <div class="displayWindow-middle">
            <p class="middleTitle">{{ baseinfo.title }}</p>
            <div class="introduction fn14">
              <div class="rowdiv">
                <div class="fn14weight">知识简介：</div>
                <div class="jianjie color777">{{ baseinfo.knowledgeInfo.content }}</div>
              </div>
              <div class="rowdiv">
                <div class="fn14weight">商品目录：</div>
                <div class="mulu color777">
                  <span v-for="(item, index) in baseinfo.goodsCatalogueParentsName">
                    <font v-if="index > 0"></font>
                    {{ item }}
                  </span>
                </div>
              </div>
              <div class="rowdiv">
                <div class="fn14weight ">商品类型：</div>
                <div class="leixing color777">
                  <span v-for="(item, index) in baseinfo.goodsCategoryParentsName">
                    <font v-if="index > 0">></font>
                    {{ item }}
                  </span>
                </div>
              </div>
            </div>
            <!-- 
            <div class="btnabsolute" style="display: flex;padding: 0px 30px;"
              v-if="baseinfo.isbuy == 'yes' || baseinfo.goodsUserBuyRecord"></div> -->

            <!-- 未购买 -->
            <div class="btnabsolute" style="display: flex;padding: 0px 30px;">
              <div class="btnStyle" v-if="!$store.state.islogined" @click="addBuyCar">
                登录后使用
                <!-- <span class="priceStyleThrough">&yen;{{ baseinfo.price }}</span> -->
              </div>
              <div class="btnStyle" v-else @click="addBuyCar">
                立即使用
                <!-- <span class="priceStyleThrough">&yen;{{ baseinfo.price }}</span> -->
              </div>
              <!-- <div class="btnStyle" v-if="baseinfo.priorityLevel == '15'" @click="addBuyCar">
                免费试用&nbsp;&nbsp;
                <span class="priceStyleThrough">&yen;{{ baseinfo.price }}</span>
              </div>
              <div class="btnStyle" v-if="baseinfo.priorityLevel == '20'" @click="buy">
                购买使用&nbsp;&nbsp;
                <span class="priceStyle">&yen;{{ baseinfo.price }}</span>
              </div> -->
            </div>

            <!-- <div class="freeTrial" v-if="baseinfo.isbuy == 'yes' || baseinfo.goodsUserBuyRecord">
              <div>{{ baseinfo.endDate | substring(3) }}前</div>
              <div></div>
              <div>可试用<span>{{ baseinfo.leavenumber }}</span>次</div>
            </div> -->
          </div>
          <div class="displayWindow-right">
            <div class="mar15">
              <div class="borderRight">咨询联系人</div>
              <div class="flexRow align">
                <div class="relationLeft">张静持</div>
                <div class="relationLeft">13594171176</div>
              </div>

            </div>
            <div class="mar15">
              <div class="borderRight">技术联系人</div>
              <div class="flexRow align">
                <div class="relationLeft">李汉雯</div>
                <div class="relationLeft">17783458059</div>
              </div>
            </div>
            <!-- <div class="mar15">
              <div class="borderRight">知识活性</div>
              <div class="labelStyle"><span>2019冬季化机会议推选</span></div>
              <div class="labelStyle"><span>使用排行榜前10</span></div>
              <div class="labelStyle"><span>Top1购买排行第一</span></div>
            </div>
            <div class="mar15">
              <div class="borderRight">知识关联</div>
              <div class="flexRow align">
                <div class="relationLeft fn14">1.冷却器(均无相变)换热面积计算</div>
                <div class="relationRight fn14">51</div>
              </div>
              <div class="flexRow align">
                <div class="relationLeft fn14">2.冷却器(均无相变)换热面积计算</div>
                <div class="relationRight fn14">56897</div>
              </div>
              <div class="flexRow align">
                <div class="relationLeft fn14">3.蒸发器(沸点进料有相变)换热面积计算</div>
                <div class="relationRight fn14">21753</div>
              </div>
              <div class="flexRow align">
                <div class="relationLeft fn14">4.冷凝器(单侧有相变)换热面积计算</div>
                <div class="relationRight fn14">52311</div>
              </div>
            </div> -->
          </div>
        </div>
        <el-tabs v-show="activeName == 'two' || activeName == 'four'" v-model="activeName" type="border-card"
          @tab-click="handleTabchange">
          <!-- <el-tab-pane label="商品详情" name="one"></el-tab-pane> -->
          <el-tab-pane name="two" style="padding-bottom: 40px;">
            <span slot="label"><span>天算</span></span>
            <div class="flexBox" v-show="baseinfo.isbuy == 'yes' || baseinfo.goodsUserBuyRecord">
              <!-- <div class="flexBox" v-show="true"> -->
              <!-- 修改 隐藏可用次数显示框 2023年10月30日20:03:45  -->
              <div class="freeTrial">
                <div>{{ baseinfo.endDate | substring(3) }}前</div>
                <div></div>
                <div>
                  可试用
                  <span>{{ baseinfo.leavenumber }}</span>
                  次
                </div>
              </div>
              <div v-if="isShowChangeBtn && baseinfo.goodsCatalogueParentsName[0] !== '数据字典'" class="changeType"
                @click="typeSetting">
                <span v-if="isDefaultType">切换到图文排版</span>
                <span v-else>切换到文字排版</span>
              </div>
            </div>
            <!-- <div class="two-tabs">
              <p v-for="item in knowledgeToolsStepList" :class="{ activeTSTab: item.knowledgeId === activeTSTab }"
                @click="changeActiveTSTab(item.knowledgeId)" :title="item.knowledgeIdTitle">
                {{ item.knowledgeIdTitle }}
              </p>
            </div> -->
            <div v-for="(step, index) in knowledgeToolsStepList" v-if="step.knowledgeId == activeTSTab">
              <!-- 第一种表格样式 start-->
              <div class="container-table" v-if="isDefaultType" v-on:keyup.enter="onEnterKeyup(index)">
                <h3 style="text-align: center;">{{ step.knowledgeIdTitle }}</h3>

                <!-- 修改 新增样式类 customTable-style 2023年10月26日14:28:41  -->
                <div class="customTable customTable-style">
                  <div class="tuwen-table-container">
                    <div v-for="detail in step.knowledgeToolsDetailAll">
                      <div class="tableRrows" v-if="detail.type == 'TITLE'">
                        <!-- 标题 -->
                        <div v-if="detail.fontSize" class="borderRightNone"
                          :style="'width:100%!important;' + detail.fontSize">
                          <span>{{ detail.title }}</span>
                        </div>
                        <div v-else class="titleStyle borderRightNone">
                          <span>{{ detail.title }}</span>
                        </div>
                      </div>

                      <div class="tableRrows hoverStyle" v-if="detail.type == 'PARAM'">

                        <!-- 参数 -->
                        <!-- <el-tooltip effect="dark" :content="detail.remark" :disabled="detail.remark == ''"
                          placement="top"> -->
                        <div>
                          <div class="borderRightNone tableRrowsFn14" style="font-weight: bold;">
                            <div>
                              {{ detail.showCode + " - " + detail.title }}
                              <span v-if="detail.unit">({{ detail.unit }})</span>
                            </div>
                          </div>
                          <div v-if="detail.remark" class="borderRightNone tableRrowsFn12">{{ detail.remark }}</div>
                        </div>
                        <!-- </el-tooltip> -->

                        <el-form ref="ruleForm" :model="detail" :rules="rules" class="secondForm" @submit.native.prevent>
                          <div v-if="detail.dataSource == 'HAND'">
                            <el-form-item prop="codevalue">
                              <el-input v-model.trim="detail.codevalue"></el-input>
                            </el-form-item>
                          </div>
                          <div v-else-if="detail.dataSource == 'DICT'">
                            <el-form-item prop="codevalue">
                              <el-input v-model.trim="detail.codevalue">
                                <el-button @click="chooseDict(detail)" slot="append" icon="el-icon-search"></el-button>
                              </el-input>
                            </el-form-item>
                          </div>
                          <div v-else-if="detail.dataSource == 'MATERIEL'">
                            <el-form-item prop="codevalue">
                              <el-select v-model="detail.codevalue" filterable clearable placeholder="请选择">
                                <el-option v-for="item in materielList" :key="item.materielId" :label="item.title"
                                  :value="item.materielId"></el-option>
                              </el-select>
                            </el-form-item>
                          </div>
                          <div v-if="detail.dataSource == 'QUOTE_FORMULA_PARAM'">
                            <el-form-item prop="codevalue">
                              <el-input v-model.trim="detail.codevalue" @submit.native.prevent></el-input>
                            </el-form-item>
                          </div>
                        </el-form>
                      </div>

                      <div class="padding0 tableRrows hoverStyle" v-if="detail.type == 'FORMULA' && detail.isHide == '1'">

                        <!-- 公式(允许显示的公式) -->
                        <div class="borderRightNone tableRrowsFn14">
                          <div style="color: #19ac38;"> {{ detail.showCode + " - " + detail.title }}
                            <span v-if="detail.unit">({{ detail.unit }})</span>
                          </div>
                          <div v-if="detail.remark" class="borderRightNone tableRrowsFn12">{{ detail.remark }}</div>
                        </div>
                        <div v-if="detail.formulaType == 'CUSTOM_FORMULA'">
                          <!-- 公式类型：自定公式（CUSTOM_FORMULA）、系统定义公式（SYS_FORMULA） -->
                          <el-input class="my-input" :disabled="true" v-model="detail.codevalue"></el-input>
                        </div>
                        <div v-if="detail.formulaType == 'SYS_FORMULA'">
                          <!-- 公式类型：自定公式（CUSTOM_FORMULA）、系统定义公式（SYS_FORMULA） -->
                          <el-input class="my-input" :disabled="true" v-model="detail.codevalue"></el-input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 知识标题 -->
                <!-- <p class="fn15" style="text-align: center;">{{ baseinfo.knowledgeInfo.subtitle }}</p> -->
                <!-- 知识副标题 -->
                <!-- <el-table :data="step.knowledgeToolsDetailAll" border style="width: 100%;" :span-method="columnSpanMethod"
                  :row-class-name="rowClassName">
                  <el-table-column type="index" label="序号" width="59px" align="left"></el-table-column>
                  <el-table-column prop="showCode" label="参数" width="100px" align="left"></el-table-column>
                  <el-table-column prop="title" label="标题" width="200px" align="left"></el-table-column>
                  <el-table-column label="参数值" width="200px" align="left">
                    <template slot-scope="scope">
                      <div v-if="scope.row.type == 'TITLE'"></div>
                      <el-form v-if="scope.row.type !== 'FORMULA'" ref="ruleForm" :model="scope.row" :rules="rules"
                        @submit.native.prevent>
                        <div v-if="scope.row.type == 'PARAM'">
                          <div v-if="scope.row.dataSource == 'HAND'" id="HAND">
                            <el-form-item prop="codevalue">
                              <el-input v-model.trim="scope.row.codevalue"></el-input>
                            </el-form-item>
                          </div>
                          <div v-else-if="scope.row.dataSource == 'DICT'" id="DICT">
                            <el-form-item prop="codevalue">
                              <el-input v-model.trim="scope.row.codevalue">
                                <el-button @click="chooseDict(scope.row)" slot="append" icon="el-icon-search"></el-button>
                              </el-input>
                            </el-form-item>
                          </div>
                          <div v-else-if="scope.row.dataSource == 'MATERIEL'" id="MATERIEL">
                            <el-form-item prop="codevalue">
                              <el-select v-model="scope.row.codevalue" filterable clearable placeholder="请选择">
                                <el-option v-for="item in materielList" :key="item.materielId" :label="item.title"
                                  :value="item.materielId"></el-option>
                              </el-select>
                            </el-form-item>
                          </div>
                          <div v-if="scope.row.dataSource == 'QUOTE_FORMULA_PARAM'">
                            <el-form-item prop="codevalue">
                              <el-input v-model.trim="scope.row.codevalue"></el-input>
                            </el-form-item>
                          </div>
                        </div>
                      </el-form>
                      <div class="padding0" v-if="scope.row.type == 'FORMULA'">
                        <div v-if="scope.row.formulaType == 'CUSTOM_FORMULA'">
                          <el-input :disabled="true" v-model="scope.row.codevalue"></el-input>
                        </div>
                        <div v-if="scope.row.formulaType == 'SYS_FORMULA'">
                          <el-input :disabled="true" v-model="scope.row.codevalue"></el-input>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="unit" label="单位" align="left" width="120px"></el-table-column>
                  <el-table-column prop="remark" label="说明" align="left" :show-overflow-tooltip="true"></el-table-column>
                </el-table> -->
              </div>
              <!-- 第一种版式end -->

              <!-- 第二种list版式start -->
              <div class="container-table" v-else v-on:keyup.enter="onEnterKeyup(index)">
                <!-- 知识标题 -->
                <h3 style="text-align: center;">{{ step.knowledgeIdTitle }}</h3>
                <!-- 知识副标题 -->
                <!-- <p class="fn15" style="text-align: center;">{{ baseinfo.knowledgeInfo.subtitle }}</p> -->

                <!-- 修改 新增样式类 customTable-style 2023年10月26日14:28:41  -->
                <div class="customTable customTable-style">
                  <!-- @zz 修改当根目录为"数据字典"时 不显示公式输入区域 2023年12月13日15:16:40 -->
                  <div v-if="baseinfo.goodsCatalogueParentsName[0] !== '数据字典'" class="table-container">
                    <div v-for="detail in step.knowledgeToolsDetailAll">
                      <div class="tableRrows" v-if="detail.type == 'TITLE'">
                        <!-- 标题 -->
                        <div v-if="detail.fontSize" class="borderRightNone"
                          :style="'width:100%!important;' + detail.fontSize">
                          <span>{{ detail.title }}</span>
                        </div>
                        <div v-else class="titleStyle borderRightNone">
                          <span>{{ detail.title }}</span>
                        </div>
                      </div>

                      <div class="tableRrows hoverStyle" v-if="detail.type == 'PARAM'">

                        <!-- 参数 -->
                        <!-- <el-tooltip effect="dark" :content="detail.remark" :disabled="detail.remark == ''"
                          placement="top"> -->
                        <div>
                          <div class="borderRightNone tableRrowsFn14" style="font-weight: bold;">
                            <div>
                              {{ detail.showCode + " - " + detail.title }}
                              <span v-if="detail.unit">({{ detail.unit }})</span>
                            </div>
                          </div>
                          <div v-if="detail.remark" class="borderRightNone tableRrowsFn12">{{ detail.remark }}</div>
                        </div>
                        <!-- </el-tooltip> @submit.native.prevent -->
                        <el-form ref="ruleForm" :model="detail" :rules="rules" class="secondForm" @submit.native.prevent>
                          <div v-if="detail.dataSource == 'HAND'">
                            <el-form-item prop="codevalue">
                              <el-input v-model.trim="detail.codevalue"></el-input>
                            </el-form-item>
                          </div>
                          <div v-else-if="detail.dataSource == 'DICT'">
                            <el-form-item prop="codevalue">
                              <el-input v-model.trim="detail.codevalue">
                                <el-button @click="chooseDict(detail)" slot="append" icon="el-icon-search"></el-button>
                              </el-input>
                            </el-form-item>
                          </div>
                          <div v-else-if="detail.dataSource == 'MATERIEL'">
                            <el-form-item prop="codevalue">
                              <el-select v-model="detail.codevalue" filterable clearable placeholder="请选择">
                                <el-option v-for="item in materielList" :key="item.materielId" :label="item.title"
                                  :value="item.materielId"></el-option>
                              </el-select>
                            </el-form-item>
                          </div>
                          <div v-if="detail.dataSource == 'QUOTE_FORMULA_PARAM'">
                            <el-form-item prop="codevalue">
                              <el-input v-model.trim="detail.codevalue"></el-input>
                            </el-form-item>
                          </div>
                        </el-form>
                      </div>

                      <div class="padding0 tableRrows hoverStyle" v-if="detail.type == 'FORMULA' && detail.isHide == '1'">

                        <!-- 公式(允许显示的公式) -->
                        <div class="borderRightNone tableRrowsFn14">
                          <div style="color: #19ac38;"> {{ detail.showCode + " - " + detail.title }}
                            <span v-if="detail.unit">({{ detail.unit }})</span>
                          </div>
                          <div v-if="detail.remark" class="borderRightNone tableRrowsFn12">{{ detail.remark }}</div>
                        </div>
                        <div v-if="detail.formulaType == 'CUSTOM_FORMULA'">
                          <!-- 公式类型：自定公式（CUSTOM_FORMULA）、系统定义公式（SYS_FORMULA） -->
                          <el-input class="my-input" :disabled="true" v-model="detail.codevalue"></el-input>
                        </div>
                        <div v-if="detail.formulaType == 'SYS_FORMULA'">
                          <!-- 公式类型：自定公式（CUSTOM_FORMULA）、系统定义公式（SYS_FORMULA） -->
                          <el-input class="my-input" :disabled="true" v-model="detail.codevalue"></el-input>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--  修改 新增图片显示区域  2023年10月26日14:26:12-->
                  <div id="pic-container-id" ref="divWidth" class="image-show-container"
                    :class="(baseinfo.goodsCatalogueParentsName[0] === '数据字典') ? 'dict-data-style' : ''">
                    <!-- <div :style="{ width: PicWidth }" style="overflow: auto; max-height: 80vh;" -->
                    <div :style="{ width: PicWidth }"
                      :class="isKnowledgePicFixed && (baseinfo.goodsCatalogueParentsName[0] !== '数据字典') ? 'image_show-box' : ''">
                      <div v-show="!isShowKnowledgePic" v-loading="!isShowKnowledgePic"></div>
                      <!-- TODO 知识图纸显示区域 -->
                      <!-- <el-image style="color: #fff;" v-loading="!isShowKnowledgePic" v-if="isShowKnowledgePic" fit="contain"
                        :src="KnowledgePic[0]" :preview-src-list="KnowledgePic" /> -->
                      <img v-if="!isShowImageViewer" style="width: 100%;" :src="KnowledgePic[showKnowledgePicIndex]"
                        fit="contain" @click="onShowImageViewer" />
                      <el-image-viewer style="color: #fff;" v-if="isShowImageViewer" v-loading="!isShowKnowledgePic"
                        :on-close="onCloseImageViewer" :url-list="KnowledgePic" hide-on-click-modal="false">
                      </el-image-viewer>
                      <div class="pagination-container">
                        <!-- <span class="demonstration">页数较少时的效果</span> -->
                        <el-pagination @current-change="onPicCurrentChange" background layout="prev, pager, next"
                          :total="KnowledgePic.length" :page-size="1" :hide-on-single-page="true">
                        </el-pagination>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 第二种版式end -->

              <!-- 天算 提交按钮  -->
              <div v-if="baseinfo.goodsCatalogueParentsName[0] !== '数据字典'" class="ts-commit-btn-box"
                v-show="!isHideCommitBtn">

                <el-button @click="cleanInputValue" class="bottomBtn-clear">
                  清除
                </el-button>

                <!-- 上一步按钮 -->
                <el-button v-if="index > 0" @click="gotoLastStepExec(index)"
                  :class="!baseinfo.goodsUserBuyRecord && baseinfo.isbuy !== 'yes' ? 'bottomBtnDisabled' : 'bottomBtn'">
                  上一步
                </el-button>

                <el-button v-if="commodityState === 'onShelves'" @click="exec(index)"
                  :class="!baseinfo.goodsUserBuyRecord && baseinfo.isbuy !== 'yes' ? 'bottomBtnDisabled' : 'bottomBtn'">
                  {{ knowledgeToolsStepList.length - 1 !== index ? '下一步' : '天算' }}
                </el-button>

                <!-- 导出world文档按钮 -->

                <el-button @click="exportWorld" :class="isExportable ? 'bottomBtn' : 'bottomBtnDisabled'"
                  :disabled="!isExportable">导出</el-button>

                <el-button class="bottomBtnDisabled" v-if="commodityState == 'expired'" :disabled="true">已过期</el-button>
                <el-button class="bottomBtnDisabled" v-if="commodityState == 'offShelves'" :disabled="true">已下架
                </el-button>
                <el-button class="bottomBtnDisabled" v-if="commodityState == 'maintain'" :disabled="true">正在维护
                </el-button>
              </div>
            </div>
          </el-tab-pane>
          <!-- <el-tab-pane name="three" label="参考资料">
            <div class="introduction tabPaneIntroduction">
              <p class="fn14weight">知识简介：</p>
              <p class="fn14 tabPanejianjie color777">{{ baseinfo.knowledgeInfo.content }}</p>
            </div>
          </el-tab-pane> -->
          <el-tab-pane name="four" label="您的建议">
            <div class="comment">
              <div class="commentContent">
                <!-- <p class="fn14Sty1">共25714条意见</p> -->
                <div class="flexRow align">
                  <div class="commentImage">
                    <img class="userPhoto" v-if="$store.state.islogined && $store.state.userImage != null"
                      :src="$store.state.defaultPicUrl + $store.state.userImage" />
                    <img class="userPhoto" v-else src="@/assets/images/touxiang.jpg" />
                  </div>
                  <div class="flex1">
                    <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="suggestionText" maxlength="1000"
                      show-word-limit></el-input>
                  </div>
                </div>
                <div class="submitBtn" @click="submitJy"><span>提交</span></div>
                <div class="commentList">
                  <div class="flexRow marBottom" v-for="item in suggestionList">
                    <div class="commentImage">
                      <img class="userPhoto" v-if="item.photo != null && item.photo != ''"
                        :src="$store.state.defaultPicUrl + item.photo" />
                      <img class="userPhoto" v-else src="@/assets/images/touxiang.jpg" />
                    </div>
                    <div class="flex1">
                      <div class="flexRow flexRowBetween">
                        <div>
                          <div>
                            <span class="fn14Sty2" style="margin-right: 10px;">{{ item.name }}</span>
                            <span class="fn14Sty2">{{ item.time }}</span>
                          </div>
                          <div class="commentText">{{ item.commentText }}</div>
                        </div>
                        <div>
                          <span class="fn14Sty2" style="vertical-align: bottom;cursor: pointer;" @click="loadJyHF(item)"
                            v-if="item.relplyTotal > 0">
                            回复({{ item.relplyTotal }})
                          </span>
                          <span class="fn14Sty2" style="vertical-align: bottom;" v-else>回复({{
                            item.relplyTotal
                          }})</span>
                          <i class="iconfont icon-dianzan yizan"></i>
                          <span v-if="item.fabulous > 0" class="fn14Sty2" style="vertical-align: bottom;">{{ item.fabulous
                          }}</span>
                        </div>
                      </div>
                      <!-- 回复内容 -->
                      <div v-if="item.showHF" class="flexRow flexRowBetween" v-for="items in item.reply">
                        <!-- <div v-if="item.reply.length>0 &&item.showHF" class="flexRow flexRowBetween" v-for="items in item.reply"> -->
                        <div class="commentImage">
                          <img class="userPhoto" v-if="items.photo != null && items.photo != ''"
                            :src="$store.state.defaultPicUrl + items.photo" />
                          <img class="userPhoto" v-else src="@/assets/images/touxiang.jpg" />
                        </div>
                        <div class="flex1">
                          <div class="flexRow flexRowBetween">
                            <div>
                              <div>
                                <span class="fn14Sty2">{{ items.name }}</span>
                                &nbsp;
                                <span class="fn14Sty2">回复</span>
                                &nbsp;
                                <span class="fn14Sty2" style="margin-right: 10px;">{{ item.name }}</span>
                                <span class="fn14Sty2">{{ items.time }}</span>
                              </div>
                              <div class="commentText">
                                <span :class="items.focus == true ? 'focus' : ''">{{ items.commentText }}</span>
                              </div>
                            </div>
                            <div>
                              <i class="iconfont icon-dianzan yizan"></i>
                              <span v-if="items.fabulous > 0" class="fn14Sty2" style="vertical-align: bottom;">{{
                                items.fabulous }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 分页 -->
                <div class="commentPage">
                  <el-pagination @size-change="handleSizeChanges" @current-change="handleCurrentChanges"
                    @prev-click="handlePrevClicks" @next-click="handleNextClicks" :current-page.sync="scurrentPage"
                    :page-sizes="[5, 10, 15, 20]" :page-size="spageSize" layout="sizes,total,prev, pager, next, jumper"
                    :total="stotal"></el-pagination>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <!-- <el-tab-pane name="seven" label="知识活性">知识活性</el-tab-pane> -->
        </el-tabs>
      </div>
    </div>

    <el-dialog :title="dialogInfo.title" :visible.sync="dialogInfo.dialogVisible" width="30%">
      <div class="errorBox">
        <div class="flexRow">
          <div class="errorButton">错误编号</div>
          <p class="errorText" v-if="dialogInfo.errorCode">{{ dialogInfo.errorCode }}</p>
          <p class="errorText" v-else>SYSUNKNOWNERROR</p>
        </div>
        <div class="flexRow">
          <div class="errorButton">错误信息</div>
          <div v-if="dialogInfo.htmlText" v-html="dialogInfo.htmlText"></div>
          <div v-else>
            <p class="errorText">对不起，系统出现了异常</p>
            <p class="errorText">请您将此问题反馈给系统管理人员</p>
            <p class="errorText">我们一定会及时修改，谢谢！</p>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogInfo.dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogInfo.dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 字典数据选择弹出框 -->
    <el-dialog title="字典数据" :lock-scroll="false" :visible.sync="searchMtk" height="100%" width="60%">
      <div style="height: 55vh;">
        <iframe ref="dict_iframe" scrolling="no" style="width: 100%;height: 100%" :src="iframeSrc"></iframe>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="getDictSelectValue">选中</el-button>
        <el-button type="primary" @click="searchMtk = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="showPicture" width="660px" class="bigPicture">
      <div class="flexRow">
        <div class="directionLeft"><i class="iconfont icon-left" @click="pictureLeft"></i></div>
        <div class="flex1">
          <div class="swiper-container swiper2">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="item in baseinfo.picarray">
                <el-image :src="'' + $store.state.defaultPicUrl + item.path + item.ftpName + ''" fit="fill" />
              </div>
            </div>
          </div>
        </div>
        <div class="directionRight"><i class="iconfont icon-you" @click="pictureRight"></i></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import navBar from '@/components/navBar';
import algorithmDetail from '@/components/algorithmDetail';
import Swiper from 'swiper';
import 'swiper/css/swiper.min.css';
import PicZoom from './PicZoom';
import breadcrumbGuid from '@/components/breadcrumbGuid';
import elImageViewer from 'element-ui/packages/image/src/image-viewer'
import store from '../store/index.js'
export default {
  name: 'toolKnowledgeDetails',
  components: {
    navBar,
    algorithmDetail,
    PicZoom,
    breadcrumbGuid,
    elImageViewer
  },
  data() {
    var checkNum = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入用户名'));
      } else {
        // 效验输入值是否是数字
        // const checkNumber = /^[0-9]+.?[0-9]*/;
        const checkNumber = /^-?(?:\d*\.\d+|\d+)$/;
        if (checkNumber.test(value))
          callback();
        else
          callback(new Error('请输入数字'));
      }
    };
    var source = (rule, value, callback) => {
      if (value === '') {
        console.log('空');
        callback();
      } else {
        console.log(value);
        callback();
      }
    };
    return {

      // TODO 导出world 文件参数定义
      isExportable: false, // 是否可以导出 world 文档 修改 新增 2023年10月26日15:22:24
      getWorldResultParam: "",
      getWorldResultParamIndex: 0,


      // TODO 知识图纸相关属性定义
      isShowKnowledgePic: false, // 是否显示 知识图纸
      isShowImageViewer: false, // 是否显示图纸大图预览
      isHideCommitBtn: false, // 当处于全屏预览时,隐藏天算提交按钮
      KnowledgePic: [], // 知识图纸 url list
      KnowledgePicWidth: 0, // 知识图纸最大宽度
      isKnowledgePicFixed: false, // 知识图纸是否开启 固定定位
      showKnowledgePicIndex: 0, // 当前显示的 知识图纸 索引

      /*------------------------ 我是分割线 ---------------------------*/

      mySwiper: '', //swiper对象
      bigPictureSwiper: '', //大图轮播
      swiperFlag: false,
      showPicture: false, //显示大图，默认不显示
      imgSrc: '', //要展示的商品图片

      isDefaultType: false, //是否显示默认的样式，false为紧凑样式
      isShowChangeBtn: true, // 是否显示图文/文字排版按钮

      searchMtk: false, //字典选择器控制隐藏
      dictCodeSelected: '', //选择字典的标签code
      iframeSrc: '',
      islogin: true, //是否登录
      user: this.$store.state.user, //会员账号\
      // 表单输入框效验规则
      rules: {
        codevalue: [
          {
            required: true,
            message: '不能为空',
            trigger: ['blur', 'change']
          },
          {
            validator: checkNum,
            trigger: ['blur', 'change']
          }
        ]
      },
      baseinfo: {
        //商品基本信息
        id: this.$route.query.id == undefined ? '' : this.$route.query.id, //商品id
        title: '', //名称
        mulu: '', //商品目录
        leixing: '', //商品分类
        goodsCatalogueParentsName: [], //商品目录层名称list
        goodsCategoryParentsName: [], //商品分类层级名称list

        description: '', //简介
        defaultpic: '', //默认显示图片
        picarray: [], //图片数组

        knowledgeInfo: {}, //知识基本信息
        // ---价格信息
        menberFreeLevel: '', //会员免费使用等级
        recommendIndex: '', //推荐指数
        priorityLevel: '', //计费优先等级
        price: '', //价格
        limitInfo: '', //使用限制信息
        endDate: '', //使用限制时间止
        number: '', //使用次数限制
        leavenumber: '0', //剩余使用次数

        //购买信息
        isbuy: this.$route.query.isbuy == undefined ? 'no' : this.$route.query.isbuy, //购买是否：已购买：yes  未购买：no
        goodsUserBuyRecord: null, //购买记录
        logsGoodsCollectionId: '', //商品收藏日志ID
        feedbackContent: '', //反馈内容
        logsGoodsPraiseId: '', //点赞日志id
        praiseType: '', //点赞类型。up（表扬），down（批评）
        logsGoodsCollectionCount: '0', //收藏总数
        logsGoodsPraiseUpCount: '0', //表扬总数
        logsGoodsPraiseDownCount: '0', //批评总数
        logsGoodsShareCount: '0', //分享总数
        logsGoodsRateId: '', //评价id
        logsGoodsRateCount: 0 //评价总数
      },
      dialogInfo: {
        //dialog对话框
        title: '提示',
        errorCode: '',//错误编号
        htmlText: '', //html文本
        dialogVisible: false //是否显示  默认否
      },
      knowledgeToolsStepList: [], //知识公式
      materielList: [], //知识相同分类的物料list
      activeName: 'one',
      // activeName: 'two', // 修改 2023年10月29日14:47:06
      // activeName: this.$route.query.isbuy == undefined ? "three" : "two",
      commodityState: 'onShelves', //商品状态： expired（已过期）、offShelves（已上架）、offShelves（已下架）、maintain（正在维护）
      // ----------------您的评论
      commentText: '', //评论内容
      commentList: [], //评论list
      currentPage: 1, //活动页号
      pageSize: 5, //页码大小
      total: 0, //全部/分页数据总数

      suggestionText: '', //建议内容
      suggestionList: [], //建议list
      scurrentPage: 1, //活动页号建议
      spageSize: 5, //页码大小建议
      stotal: 0, //全部/分页数据总数建议
      rateValue: null, //商品评分
      activeTSTab: '' //天算二级选项卡激活项
    };
  },
  watch: {
    //route.push进来后没有执行获取数据的方法可以watch下路由，有变化后再次获取数据，而不是靠刷新一次来获取数据
    '$route.query.id'(to, from) {
      //监测路由发生变化 刷新本页
      location.reload();
    }
  },

  computed: {
    PicWidth() {
      return this.KnowledgePicWidth + 'px';
    }

  },

  created: function () {
    //主页面监听数据字典返回值
    // window.addEventListener('message', function (e) {
    //   if (e && e.data && e.data.selectVal) {
    //     console.log('子页面参数：', e.data);
    //     // this.searchMtk = false;
    //   }
    // });
    //处理url访问查看建议
    if (this.$route.query.showjy) {
      this.activeName = 'four';
      //建议id
      let suggestionid = this.$route.query.suggestionid;
      //回复id
      let replyid = this.$route.query.replyid;

      this.loadJyDetail(suggestionid, replyid);
    }
    //初始化加载商品信息
    this.loadGoodsInfo();
    //保存访问日志
    this.saveLogsGoodsAccess();
  },
  mounted() {

    window.addEventListener('message', this.handleChildMessage); //监听子页面的消息
    window.addEventListener('scroll', this.handleScroll, true);
    // TODO 设置知识图纸宽度
    setTimeout(() => {
      if (this.baseinfo.goodsCatalogueParentsName !== '数据字典') {
        if (!this.isDefaultType) {
          this.isShowKnowledgePic = true;
          if (this.$refs.divWidth[0].offsetWidth) {
            this.KnowledgePicWidth = this.$refs.divWidth[0].offsetWidth - 100;
          }
        }
      }
      // this.$refs.elImage.style.width = this.$refs.divWidth[0].offsetWidth;
      // console.log(this.$refs.imageShowBox);
    }, 1000)
  },
  destroyed() {
    //离开这个界面之后，删除滚动事件，不然容易除bug
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {

    onEnterKeyup(index) {
      // console.log("点击回车键了");
      this.exec(index)
    },

    // 行的样式控制方法，通过这个回调方法控制隐藏显示
    rowClassName({ row }) {
      if (row.isHide !== '1') {
        return 'showRow'
      }
      return '';
    },


    // TODO 一键清空输入框数据
    cleanInputValue() {
      this.$confirm('将为清空所有默认输入参数, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          message: '清除默认参数完成!',
          type: 'success'
        });
        this.knowledgeToolsStepList.forEach(element => {
          element.knowledgeToolsDetailAll.forEach(item => {
            if (item.type === 'PARAM') {
              item.codevalue = '';
            }
          })
        })
      })
    },

    // TODO 导出world计算结果文档 请求
    exportWorld() {
      this.$confirm('将计算结果导出为word文件, 是否继续?', '提示', {
        confirmButtonText: '下载到本地',
        cancelButtonText: '取消',
        type: 'success '
      }).then(() => {
        const requestWorldResultParam = JSON.parse(this.getWorldResultParam);
        // requestWorldResultParam.url = "/SJHG/publicplat/goods/goods/downloadCalcWord";
        // console.log(requestWorldResultParam);

        let url = "/SJHG/publicplat/goods/goods/downloadCalcWord?"
        let query = "goodsId=" + requestWorldResultParam.data_.goodsId + "&knowledgeNo=" + requestWorldResultParam.data_.knowledgeNo + "&paramsJson=" + requestWorldResultParam.data_.paramsJson;
        // console.log(url + encodeURIComponent(query));
        window.open(url + query);

        // this.axiosPost(requestWorldResultParam, this.downloadCalcWord, '', this.getWorldResultParamIndex); //初始化加载商品目录

        // this.$message.error('此功能正在努力开发中...');
        // this.$message({
        //   type: 'success',
        //   message: '下载成功!'
        // });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消下载'
        });
      });
    },

    downloadCalcWord(res, index) {

      let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=utf-8' });
      let objectUrl = URL.createObjectURL(blob);
      window.location.href = objectUrl;
      // console.log(res.data, index);
    },

    // TODO 交换知识图纸数组顺序
    swapKnowledgeImages(knowledgeImages, index) {
      let temp = knowledgeImages[0];
      knowledgeImages[0] = knowledgeImages[index];
      knowledgeImages[index] = temp;
    },
    reswapKnowledgeImages(knowledgeImages, index) {
      let temp = knowledgeImages[index];
      knowledgeImages[index] = knowledgeImages[0];
      knowledgeImages[0] = temp;
    },

    // TODO 开启知识图纸预览, 当开启预览时, 禁用浏览器滚动条,隐藏天算及导出按钮
    onShowImageViewer() {
      // 交换知识图纸数组顺序
      if (this.KnowledgePic.length > 1&&this.showKnowledgePicIndex!==0) {
        // console.log('onShowImageViewer');
        this.swapKnowledgeImages(this.KnowledgePic, this.showKnowledgePicIndex);
      }
      this.isShowImageViewer = true;
      document.documentElement.style.overflowY = 'hidden';
      this.isHideCommitBtn = true; // 
    },
    // 关闭知识图纸预览
    onCloseImageViewer() {

      if (this.KnowledgePic.length > 1&&this.showKnowledgePicIndex!==0) {
        this.reswapKnowledgeImages(this.KnowledgePic, this.showKnowledgePicIndex);
      }

      this.isShowImageViewer = false;
      this.isHideCommitBtn = false;
      document.documentElement.style.overflowY = 'scroll';
    },

    // TODO 页面滚动事件监听处理函数
    handleScroll() {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      // var offsetTop = document.querySelector('#pic-container-id').offsetTop // 获取所需元素到文档顶部的距离，然后判断滚动条位置让该元素是否固定定位
      if (scrollTop > 300) {
        this.isKnowledgePicFixed = true
      } else {
        this.isKnowledgePicFixed = false
      }

    },

    // TOD 图纸分页预览改变时触发
    onPicCurrentChange(index) {
      // console.log(index);
      this.showKnowledgePicIndex = index - 1
    },


    // timeDiff(endDate) {
    //   let endDateTimestamp = new Date(endDate).getTime(),
    //     nowTimestamp = new Date().getTime();
    //   return endDateTimestamp > nowTimestamp;
    // },
    //搜索
    redrectSearchInfo(params) {
      let searchText = params.searchText;
      let searchType = params.searchType;
      this.$router.push({
        path: '/knowledgeMarket',
        query: {
          searchText: searchText,
          searchType: searchType
        }
      });
    },
    //轮播向左的方法
    handleLeft() {
      this.mySwiper.slidePrev();
      this.imgChange(this.mySwiper.realIndex);
    },
    //轮播向右的方法
    handleRight() {
      if (this.mySwiper.realIndex == this.baseinfo.picarray.length - 1) {
        return;
      } else {
        this.mySwiper.slideNext();
        this.imgChange(this.mySwiper.realIndex);
      }
    },
    loadGoodsInfo() {
      let _this = this;
      //加载商品信息
      var params = {
        url: '/SJHG/publicplat/goods/goods/getGoodsInfoJson',
        data_: {
          id: this.baseinfo.id,
          userid: this.user != null ? this.user.id : ''
        }
      };
      //获取数据成功回调方法
      let loadGoodsInfoDetail = function (res) {
        if (res.data.ok) {
          let resultdata = res.data.result;
          // console.log(  '商品详情',resultdata)
          //0.设置商品目录导航
          _this.$refs.breadcrumbGuidContainer.loadBreadcrumbGuid(resultdata.sameParentIdGoodsCatalogue);

          //商品状态： expired（已过期）、offShelves（已上架）、offShelves（已下架）、maintain（正在维护）
          //默认商品maintain（正在维护）
          let commodityState = 'maintain';

          // 1.商品基本信息 resultdata.goodsInfo
          let baseDetail = resultdata.goodsInfo;
          _this.baseinfo.title = baseDetail.name;
          _this.baseinfo.defaultpic = baseDetail.showPicPath;
          //商品目录
          if (baseDetail.goodsCatalogueId.name) _this.baseinfo.mulu = baseDetail.goodsCatalogueId.name;
          //商品分类
          if (baseDetail.category) _this.baseinfo.leixing = baseDetail.category.name;
          //商品目录层级名称
          if (resultdata.goodsCatalogueParentsName) _this.baseinfo.goodsCatalogueParentsName = resultdata.goodsCatalogueParentsName;
          // console.log("商品目录层级名称:", _this.baseinfo.goodsCatalogueParentsName[0]);
          //商品分类层级名称
          if (resultdata.goodsCategoryParentsName) _this.baseinfo.goodsCategoryParentsName = resultdata.goodsCategoryParentsName;

          if (baseDetail.status) {
            let status_ = baseDetail.status;
            if ('offShelves' == status_) {
              //offShelves(已下架)
              commodityState = 'offShelves';
            } else if ('onShelves' == status_) {
              //onShelves（已上架）
              commodityState = 'onShelves';
            } else {
              //maintain（正在维护）
              commodityState = 'maintain';
            }
          }

          // 1.1商品图片信息
          let listPic = resultdata.listPic;
          _this.baseinfo.picarray = listPic;
          let showImgSrc = '';
          if (!listPic || listPic.length == 0) {
            //商品无图片时设置默认图片 add 20201209
          } else {
            showImgSrc = _this.$store.state.defaultPicUrl + _this.baseinfo.picarray[0].path + _this.baseinfo.picarray[0].ftpName;
            //默认展示第一张图
            _this.imgSrc = showImgSrc;
          }

          // 新增:  获取知识图纸 2023年10月29日16:21:29
          let KnowledgeImages = resultdata.KnowledgePictureInfo;
          // console.log(KnowledgeImages);
          if (KnowledgeImages.length > 0) {
            if (_this.KnowledgePic.length > 0) {
              _this.KnowledgePic.length = 0;
            }
            KnowledgeImages.forEach(item => {
              _this.KnowledgePic.push(_this.$store.state.defaultPicUrl + item.path + item.ftpName)
              // console.log("展示图片信息: ", _this.KnowledgePic);
            })
          } else {
            _this.isDefaultType = true; // 如果知识图纸没有,这显示文字排版
            _this.isShowChangeBtn = false; // 隐藏图文排版切换按钮
          }

          _this.swiperFlag = true;
          _this.swiperInit(); //初始化录播

          //2.知识信息
          let knowledgeInfos = resultdata.knowledgeInfos;
          if (knowledgeInfos && knowledgeInfos.length > 0) {
            _this.baseinfo.knowledgeInfo = knowledgeInfos[0]; //知识信息
          }

          //4.0默认使用限制
          //限制信息
          let limitInfo = '';
          //有效期至
          let endDate = '';
          //总使用次数
          let number = '';
          //剩余可使用次数
          let leavenumber = '';
          //会员免费使用等级
          let menberFreeLevel = '';
          //推荐指数
          let recommendIndex = '';
          //计费优先等级
          let priorityLevel = '';

          //4.1价格信息
          let piceInfo = resultdata.goodsPriceInfo;
          if (piceInfo) {
            _this.baseinfo.price = piceInfo.price;
            endDate = piceInfo.endDate;

            limitInfo = piceInfo.limitInfo;
            endDate = piceInfo.endDate;
            number = piceInfo.number;
            leavenumber = piceInfo.number;

            menberFreeLevel = piceInfo.menberFreeLevel;
            recommendIndex = piceInfo.recommendIndex;
            priorityLevel = piceInfo.priorityLevel;
          }
          _this.baseinfo.menberFreeLevel = menberFreeLevel;
          _this.baseinfo.recommendIndex = recommendIndex;
          _this.baseinfo.priorityLevel = priorityLevel;
          //buyRecord
          //4.2有本商品购买记录
          let goodsUserBuyRecord_ = resultdata.goodsUserBuyRecord;
          if (!goodsUserBuyRecord_) {
            goodsUserBuyRecord_ = null;
            _this.baseinfo.isbuy = 'no';
          } else {
            if (_this.activeName == 'one') {
              _this.activeName = 'two'; //购买后默认显示天算
            }

            _this.baseinfo.isbuy = 'yes';

            //		总使用次数
            number = goodsUserBuyRecord_.allNumber;
            //		剩余使用次数
            leavenumber = goodsUserBuyRecord_.notUsedNumber;
            //		结束使用时间。商品有效期开始时间，格式yyyy-mm-dd HH:mm:ss
            endDate = goodsUserBuyRecord_.endUseTime;
          }
          _this.baseinfo.goodsUserBuyRecord = goodsUserBuyRecord_;

          _this.baseinfo.limitInfo = limitInfo;
          _this.baseinfo.endDate = endDate;
          _this.baseinfo.number = number;
          _this.baseinfo.leavenumber = leavenumber;

          if (!endDate || new Date().getTime() - new Date(endDate) >= 0) {
            //expired（已过期）
            commodityState = 'expired';
          }
          _this.commodityState = commodityState;

          //5.商品知识公式
          let knowledgeToolsStepList = resultdata.knowledgeToolsStepList;
          _this.knowledgeToolsStepList = knowledgeToolsStepList;
          //设置默认选中知识
          _this.activeTSTab = knowledgeToolsStepList[0].knowledgeId;

          let knowledgeToolsStep_ = resultdata.knowledgeToolsStepList[0];
          //全部知识详情
          //初始化参数默认值
          knowledgeToolsStepList.forEach((step, index1) => {
            step.knowledgeToolsDetailAll.forEach((item, index, arr) => {
              if (item.type == 'PARAM' && (item.dataSource == 'HAND' || item.dataSource == 'DICT')) {
                //设置录入项默认值
                if (item.remark1) {
                  _this.$set(item, 'codevalue', item.remark1);
                }
              }
            });
          });

          //组装知识相同分类下的物料list
          _this.materielList = resultdata.materielListMap == undefined ? [] : resultdata.materielListMap;

          //组装日志信息
          let logs = resultdata.logs;
          if (logs.logsGoodsCollectionId) {
            _this.baseinfo.logsGoodsCollectionId = logs.logsGoodsCollectionId;
          }
          if (logs.logsGoodsPraiseId) {
            _this.baseinfo.logsGoodsPraiseId = logs.logsGoodsPraiseId;
            _this.baseinfo.praiseType = logs.praiseType;
          }

          if (logs.logsGoodsPraiseUpCount) {
            _this.baseinfo.logsGoodsPraiseUpCount = logs.logsGoodsPraiseUpCount;
          }
          if (logs.logsGoodsPraiseDownCount) {
            _this.baseinfo.logsGoodsPraiseDownCount = logs.logsGoodsPraiseDownCount;
          }
          if (logs.logsGoodsCollectionCount) {
            _this.baseinfo.logsGoodsCollectionCount = logs.logsGoodsCollectionCount;
          }
          if (logs.logsGoodsShareCount) {
            _this.baseinfo.logsGoodsShareCount = logs.logsGoodsShareCount;
          }
          //商品评价
          if (logs.logsGoodsRateId) {
            _this.baseinfo.logsGoodsRateId = logs.logsGoodsRateId;
          }
          if (logs.logsGoodsRateCount) {
            _this.baseinfo.logsGoodsRateCount = logs.logsGoodsRateCount;
          }
          if (logs.logsGoodsRate) {
            _this.rateValue = Number(logs.logsGoodsRate);
          }
        } else {
          _this.$alert(res.data, '加载商品信息异常', {
            dangerouslyUseHTMLString: true
          });
        }
      };

      this.axiosPost(params, loadGoodsInfoDetail); //初始化加载商品目录
    },
    //异步请求
    axiosPost(params, successCallback, failedCallback, index) {
      let this_ = this;
      let paramdata = {};
      paramdata.url = params.url;
      paramdata.data = params.data_; //json对象
      paramdata.onSuccess = res => {
        if (successCallback) {
          successCallback(res, index);
        }
      };
      paramdata.onFailed = function (res) {
        if (failedCallback) {
          failedCallback(res);
        }
      };
      this_.$axiosUtil.postServer(paramdata);
    },

    // 多步骤计算,切换到上一步按钮处理
    gotoLastStepExec(index) {
      this.changeActiveTSTab(this.knowledgeToolsStepList[index - 1].knowledgeId)
    },

    // 知识计算提交事件
    exec(index) {
      let _this = this;

      //2.操作账号
      let userid_ = _this.$store.state.userId != null ? _this.$store.state.userId : '';

      if (!userid_) {
        _this
          .$confirm('请先登录账号, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            _this.redirectLogin();
          })
          .catch(() => {
          });
        return;
      }

      if (!(_this.baseinfo.isbuy == 'yes' || _this.baseinfo.goodsUserBuyRecord)) {
        _this.$message({
          message: '未购买，不能使用！',
          type: 'warning'
        });
        return;
      }
      //校验是否允许使用
      if (Number(_this.baseinfo.leavenumber) <= 0) {
        _this.$message({
          message: '可使用次数不足！',
          type: 'warning'
        });
        return;
      }

      //组装计算所需的json参数
      let objJson = {};

      //校验信息(不空时校验未通过不能执行天算操作)
      let validateMsg = '';
      //公式参数
      //选中知识
      let activeTSTab = _this.activeTSTab;
      // _this.knowledgeToolsStepList;

      //获取选中知识
      let activeKnowledgeToolsStep = _this.knowledgeToolsStepList.filter(item => item.knowledgeId == activeTSTab)[0];

      //组装选中知识参数
      activeKnowledgeToolsStep.knowledgeToolsDetailAll.forEach(item => {
        if (item.type == 'PARAM') {
          if (item.dataSource == 'MATERIEL') {
            objJson['dataValue'] = item.codevalue;
          } else if (item.dataSource == 'DICT') {
            objJson[item.code] = item.codevalue;
          } else if (item.dataSource == 'QUOTE_FORMULA_PARAM') {
            objJson[item.code] = item.codevalue;
          }
          {
            objJson[item.code] = item.codevalue;
          }
          if (!item.codevalue) {
            if (validateMsg) {
              validateMsg += '、';
            }
            validateMsg += item.code + '-' + item.title;
            if (item.unit) {
              validateMsg += '(' + item.unit + ')';
            }
          }
        }
      });

      //参数不能为空
      if (validateMsg) {
        _this.$message({
          message: '请录入必要参数：' + validateMsg,
          type: 'warning'
        });
        //执行element的验证，将提示信息显示出来
        _this.$refs['ruleForm'].forEach(item => {
          if (!item.disabled) {
            //input框被disabled则不需要验证
            item.validate(valid => {
              if (!valid) {
                return false;
              } else {
                return true;
              }
            });
          }
        });
        return;
      }

      //公式属性符号（此时值为空 由计算得出结果）
      activeKnowledgeToolsStep.knowledgeToolsDetailAll.forEach(item => {
        if (item.type == 'FORMULA') {
          objJson[item.code] = item.codevalue;
        }
      });
      objJson['knowledgeNo'] = activeKnowledgeToolsStep.knowledgeNoMd5;
      objJson['knowledgeId'] = activeKnowledgeToolsStep.knowledgeId;
      //知识公式form表单json
      let paramsJson = JSON.stringify(objJson);

      //加载商品信息
      var params = {
        url: '/SJHG/publicplat/goods/goods/calc',
        data_: {
          goodsId: _this.baseinfo.id, //商品id
          knowledgeNo: activeKnowledgeToolsStep.knowledgeNoMd5, //知识noMD5
          paramsJson: paramsJson
        }
      };

      this.getWorldResultParam = JSON.stringify(params);
      this.getWorldResultParamIndex = index;
      this.axiosPost(params, _this.loadCalcResult, '', index);
    },

    loadCalcResult(res, index) {
      //加载计算结果
      let _this = this;

      if (res.data.ok) {
        var calc_result = res.data.result.calc_result;
        if (!calc_result) {
          var calcMsg = res.data.result.calcMsg;
          _this.$message({
            message: t + '失败,原因：' + calcMsg,
            type: 'error'
          });
          return;
        }
        //2、遍历公式数组获取计算结果值并加载到页面
        var calc_result_jsonObj = JSON.parse(calc_result);
        // console.log(calc_result_jsonObj);
        //获取选中知识

        //更新选中知识的计算结果值
        _this.knowledgeToolsStepList.forEach(step => {
          if (step.knowledgeId == _this.activeTSTab) {
            step.knowledgeToolsDetailAll.forEach(item => {
              if (item.type == 'FORMULA') {
                var jValue = calc_result_jsonObj[item.code + '_string'] || calc_result_jsonObj[item.code + '_scale_value'] || calc_result_jsonObj[item.code]; //key所对应的value C16_scale_value
                if (jValue) {
                  /* item.codevalue = jValue; */
                  _this.$set(item, 'codevalue', jValue);
                }
              }
            });
          }
        });

        //3.更新页面限制信息和控制天算按钮状态
        var goodsUserBuyRecord = res.data.result.goodsUserBuyRecord;
        if (goodsUserBuyRecord) {
          //3.1更新限制信息
          // 剩余使用次数
          _this.baseinfo.number = goodsUserBuyRecord.allNumber;
          _this.baseinfo.leavenumber = goodsUserBuyRecord.notUsedNumber;

          // 商品到期时间
          _this.baseinfo.endDate = goodsUserBuyRecord.endUseTime;
          //控制商品是否到期
          let endDate = goodsUserBuyRecord.endUseTime;
          if (!endDate || new Date().getTime() - new Date(endDate) >= 0) {
            //expired（已过期）
            _this.commodityState = 'expired';
          }
        }

        if (index >= 0) {
          if (_this.knowledgeToolsStepList.length - 1 !== index) {
            _this.changeActiveTSTab(_this.knowledgeToolsStepList[index + 1].knowledgeId)
          }
        }

        // 激活导出按钮
        if (_this.knowledgeToolsStepList.length - 1 == index) {
          this.isExportable = true; // 修改 新增 当计算成功后 激活导出按钮状态为可用状态. 2023年10月26日15:25:56
          this.$message({
            showClose: true,
            message: '计算完成,您可以将结果导出为world文件.',
            type: 'success'
          });
        }


      } else {
        _this.dialogInfo.title = '天算失败提示';
        _this.dialogInfo.errorCode = res.data.errcode;
        _this.dialogInfo.htmlText = res.data.errmsg;
        _this.dialogInfo.dialogVisible = true;
      }
    },
    // ==========================商品购买操作 start========================================
    // 加入购物车
    addBuyCar() {
      // this.doSomeThing('addBuyCar', '加入购物车');
      this.doSomeThing('addBuyCar', '');
      // console.log('加入购物车');
    },
    // 立即购买
    buy() {
      // this.doSomeThing('buy', '立即购买');
      this.doSomeThing('buy', '');
      // console.log('立即购买');
    },
    doSomeThing(f, t) {
      let _this = this;

      //1.商品id
      let goodsid = _this.baseinfo.id;
      //2.操作账号
      let userid_ = _this.$store.state.userId != null ? _this.$store.state.userId : '';

      if (!userid_) {
        _this
          .$confirm('即将为您跳转到登陆页面, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            _this.redirectLogin();
          })
          .catch(() => {
          });
        return;
      }

      //请求后台操作
      let paramdata = {};
      (paramdata.url = '/SJHG/publicplat/goods/goods/goodsOpt'),
        (paramdata.data = {
          goodsId: goodsid, //商品id
          userid: userid_, //账号id
          opt: f //操作
        });
      //操作成功回调方法
      paramdata.onSuccess = function (res) {
        if (res.data.ok) {
          // var data_ = res.data.result;
          // //跳转商品订单页面
          // _this.$router.push({
          //   path: "/memberCenterIndex/KnowledgeOrder",
          //   query: {
          //     "orderId": data_.id
          //   }
          // });

          location.reload();
        } else {
          if (res.data) {
            res.data = res.data.replace('<a href="javascript:" onclick="history.go(-1);" class="btn">返回上一页</a>', '');
          }
          _this.dialogInfo.title = '提示';
          _this.dialogInfo.errorCode = res.data.errcode;
          _this.dialogInfo.htmlText = res.data.errmsg;
          _this.dialogInfo.dialogVisible = true;
        }
      };
      paramdata.onFailed = function (res) {
      };
      _this.$axiosUtil.postServer(paramdata);
    },
    // ==========================商品购买操作 end========================================
    //初始化swiper
    swiperInit() {
      var _this = this;
      this.$nextTick(() => {
        this.mySwiper = new Swiper('.swiper1', {
          autoplay: false, //可选选项，自动滑动
          // slidesPerView: 3,
          // spaceBetween: 20,
          normalizeSlideIndex: false,

          on: {
            click: function (event) {
              this.slideTo(this.clickedIndex);
              _this.imgChange(this.clickedIndex);
            }
          }
        });
      });
    },
    imgChange(index) {
      let showImgSrc = '';
      if (!this.baseinfo.picarray || this.baseinfo.picarray.length == 0) {
      } else {
        showImgSrc = this.$store.state.defaultPicUrl + this.baseinfo.picarray[index].path + this.baseinfo.picarray[index].ftpName;
        this.imgSrc = showImgSrc;
      }
    },
    // ==========================日志操作 end========================================
    //保存访问日志
    saveLogsGoodsAccess() {
      let _this = this;

      //1.商品id
      let goodsid = _this.baseinfo.id;
      //2.操作账号
      let userid_ = _this.$store.state.userId != null ? _this.$store.state.userId : '';
      if (!userid_) {
        //账号未登录不保存访问日志
        return;
      }
      //请求后台操作
      let paramdata = {};
      (paramdata.url = '/SJHG/logs/common/logscommon/saveLogsGoodsAccess'),
        (paramdata.data = {
          goodsId: goodsid //商品id
        });
      _this.$axiosUtil.postServer(paramdata);
    },
    //保存收藏日志
    saveLogsGoodsCollection() {
      let _this = this;

      //1.商品id
      let goodsid = _this.baseinfo.id;
      //2.操作账号
      let userid_ = _this.$store.state.userId != null ? _this.$store.state.userId : '';
      //收藏日志id
      let logId = _this.baseinfo.logsGoodsCollectionId;
      let mes_ = '';
      if (logId) {
        mes_ = '取消关注';
      } else {
        mes_ = '关注';
      }
      if (!userid_) {
        _this
          .$confirm('请先登录账号再' + mes_ + ', 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            _this.redirectLogin();
          })
          .catch(() => {
          });
        return;
      }

      //请求后台操作
      let paramdata = {};
      (paramdata.url = '/SJHG/logs/common/logscommon/saveLogsGoodsCollection'),
        (paramdata.data = {
          goodsId: goodsid, //商品id
          logId: logId //商品id
        });
      //请求成功
      paramdata.onSuccess = function (res) {
        if (res.data.ok) {
          var data_ = res.data.result;
          if (logId) {
            //有日志id 则为取消  无则为新增
            //更新当前页参数
            _this.baseinfo.logsGoodsCollectionId = '';
            if (_this.baseinfo.logsGoodsCollectionCount && Number(_this.baseinfo.logsGoodsCollectionCount) > 0)
              _this.baseinfo.logsGoodsCollectionCount = Number(_this.baseinfo.logsGoodsCollectionCount) - 1;
          } else {
            _this.baseinfo.logsGoodsCollectionId = data_;
            let logsGoodsCollectionCount_ = _this.baseinfo.logsGoodsCollectionCount;
            if (!logsGoodsCollectionCount_) {
              logsGoodsCollectionCount_ = 0;
            }
            _this.baseinfo.logsGoodsCollectionCount = Number(logsGoodsCollectionCount_) + 1;
          }
        }
      };
      _this.$axiosUtil.postServer(paramdata);
    },
    //保存商品反馈日志
    saveLogsGoodsFeedback() {
      let _this = this;

      //1.商品id
      let goodsid = _this.baseinfo.id;
      //2.操作账号
      let userid_ = _this.$store.state.userId != null ? _this.$store.state.userId : '';
      if (!userid_) {
        _this
          .$confirm('请先登录账号再提交反馈信息, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            _this.redirectLogin();
          })
          .catch(() => {
          });
        return;
      }
      //收藏日志id
      let feedbackContent = _this.feedbackContent;
      //请求后台操作
      let paramdata = {};
      (paramdata.url = '/SJHG/logs/common/logscommon/saveLogsGoodsFeedback'),
        (paramdata.data = {
          goodsId: goodsid, //商品id
          feedbackContent: feedbackContent //商品id
        });
      _this.$axiosUtil.postServer(paramdata);
    },
    //保存商品反馈日志
    saveLogsGoodsPraise(f) {
      let _this = this;

      //1.商品id
      let goodsid = _this.baseinfo.id;
      //2.操作账号
      let userid_ = _this.$store.state.userId != null ? _this.$store.state.userId : '';
      if (!userid_) {
        _this
          .$confirm('请先登录账号再顶或踩, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            _this.redirectLogin();
          })
          .catch(() => {
          });
        return;
      }
      //点赞类型。up（表扬），down（批评）
      let praiseType = f;
      //原点赞类型。up（表扬），down（批评）
      let oldPraiseType = _this.baseinfo.praiseType;

      //点赞日志id
      let logId = _this.baseinfo.logsGoodsPraiseId;

      //请求后台操作
      let paramdata = {};
      (paramdata.url = '/SJHG/logs/common/logscommon/saveLogsGoodsPraise'),
        (paramdata.data = {
          goodsId: goodsid,
          praiseType: praiseType,
          oldPraiseType: oldPraiseType,
          logId: logId
        });

      //请求成功
      paramdata.onSuccess = function (res) {
        if (res.data.ok) {
          var data_ = res.data.result;
          _this.baseinfo.praiseType = praiseType;

          if (logId) {
            //有日志id 则为取消  无则为新增
            //更新当前页参数

            if (praiseType == oldPraiseType) {
              //新旧点赞类型相同则为取消点赞
              _this.baseinfo.logsGoodsPraiseId = '';
              if (praiseType == 'up') {
                let logsGoodsPraiseUpCount = _this.baseinfo.logsGoodsPraiseUpCount;
                if (logsGoodsPraiseUpCount) {
                  logsGoodsPraiseUpCount = Number(logsGoodsPraiseUpCount) - 1;
                } else {
                  logsGoodsPraiseUpCount = 0;
                }
                _this.baseinfo.logsGoodsPraiseUpCount = logsGoodsPraiseUpCount;
              } else if (praiseType == 'down') {
                let logsGoodsPraiseDownCount = _this.baseinfo.logsGoodsPraiseDownCount;
                if (logsGoodsPraiseDownCount) {
                  logsGoodsPraiseDownCount = Number(logsGoodsPraiseDownCount) - 1;
                } else {
                  logsGoodsPraiseDownCount = 0;
                }
                _this.baseinfo.logsGoodsPraiseDownCount = logsGoodsPraiseDownCount;
              }
            } else if (praiseType == 'up') {
              //点赞类型更换为down=>up  up数量加1  down数量减1
              let logsGoodsPraiseUpCount = _this.baseinfo.logsGoodsPraiseUpCount;
              if (!logsGoodsPraiseUpCount) {
                logsGoodsPraiseUpCount = 0;
              }
              _this.baseinfo.logsGoodsPraiseUpCount = Number(logsGoodsPraiseUpCount) + 1;

              let logsGoodsPraiseDownCount = _this.baseinfo.logsGoodsPraiseDownCount;
              if (!logsGoodsPraiseDownCount) {
                logsGoodsPraiseDownCount = Number(logsGoodsPraiseDownCount) - 1;
              } else {
                logsGoodsPraiseDownCount = 0;
              }
              _this.baseinfo.logsGoodsPraiseDownCount = logsGoodsPraiseDownCount;
            } else if (praiseType == 'down') {
              //点赞类型更换为up=>down down数量加1  up数量减1
              let logsGoodsPraiseDownCount = _this.baseinfo.logsGoodsPraiseDownCount;
              if (!logsGoodsPraiseDownCount) {
                logsGoodsPraiseDownCount = 0;
              }
              _this.baseinfo.logsGoodsPraiseDownCount = Number(logsGoodsPraiseDownCount) + 1;

              let logsGoodsPraiseUpCount = _this.baseinfo.logsGoodsPraiseUpCount;
              if (!logsGoodsPraiseUpCount) {
                logsGoodsPraiseUpCount = Number(logsGoodsPraiseUpCount) - 1;
              } else {
                logsGoodsPraiseUpCount = 0;
              }
              _this.baseinfo.logsGoodsPraiseUpCount = logsGoodsPraiseUpCount;
            }
          } else {
            _this.baseinfo.logsGoodsPraiseId = data_;
            if (praiseType == 'up') {
              let logsGoodsPraiseUpCount = _this.baseinfo.logsGoodsPraiseUpCount;
              if (!logsGoodsPraiseUpCount) {
                logsGoodsPraiseUpCount = 0;
              }
              _this.baseinfo.logsGoodsPraiseUpCount = Number(logsGoodsPraiseUpCount) + 1;
            } else if (praiseType == 'down') {
              let logsGoodsPraiseDownCount = _this.baseinfo.logsGoodsPraiseDownCount;
              if (!logsGoodsPraiseDownCount) {
                logsGoodsPraiseDownCount = 0;
              }
              _this.baseinfo.logsGoodsPraiseDownCount = Number(logsGoodsPraiseDownCount) + 1;
            }
          }
        }
      };
      _this.$axiosUtil.postServer(paramdata);
    },
    //保存商品分享日志
    saveLogsGoodsShare() {
      let _this = this;

      //1.商品id
      let goodsid = _this.baseinfo.id;
      //2.操作账号
      let userid_ = _this.$store.state.userId != null ? _this.$store.state.userId : '';
      if (!userid_) {
        _this
          .$confirm('请先登录账号再分享, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            _this.redirectLogin();
          })
          .catch(() => {
          });
        return;
      }
      //请求后台操作
      let paramdata = {};
      (paramdata.url = '/SJHG/logs/common/logscommon/saveLogsGoodsShare'),
        (paramdata.data = {
          goodsId: goodsid //商品id
        });

      //请求成功
      paramdata.onSuccess = function (res) {
        if (res.data.ok) {
          var data_ = res.data.result;
          let logsGoodsShareCount_ = _this.baseinfo.logsGoodsShareCount;
          if (!logsGoodsShareCount_) {
            logsGoodsShareCount_ = 0;
          }
          _this.baseinfo.logsGoodsShareCount = Number(logsGoodsShareCount_) + 1;
        }
      };
      _this.$axiosUtil.postServer(paramdata);
    },
    chooseDict(item) {
      //打开字典知识窗口
      this.searchMtk = true;
      this.iframeSrc = '/SJHG/publicplat/goods/goods/viewKnowledgeDict?knowledgeDictId=' + item.dataDict + '&knowledgeDictCode=' + item.code;
      //设置选中字典code
      this.dictCodeSelected = item.code;
    },
    //获取字典选中值
    getDictSelectValue() {

      //消息结构
      var mesparam = {
        fun: 'getSelected', //调用子页面方法名
        dictCodeSelected: this.dictCodeSelected, //选择字典的标签code
        clientip: this.$store.state.defaultLocalUrl //本项目协议+主机+端口号
        // clientip: 'http://localhost:8080/' //本项目协议+主机+端口号
      };
      //childDomain是子页面的源（协议+主机+端口号）
      var childDomain = this.$store.state.defaultLocalUrl;
      // var childDomain = 'http://localhost:8080/';
      this.$refs.dict_iframe.contentWindow.postMessage(mesparam, childDomain);
    },
    //处理子页面消息
    handleChildMessage(event) {
      const data = event.data;
      if (data.ok === true) {
        if (data.fun === 'getSelected') {
          this.searchMtk = false; //关闭字典选择器
          let select = data.dictCodeSelected || this.dictCodeSelected;
          let jValue = data.result;
          //更新标签选中值 data.result
          this.knowledgeToolsStepList.forEach(item => {
            item.knowledgeToolsDetailAll.forEach(item2 => {
              if (item2.code == select) {
                this.$set(item2, 'codevalue', jValue);
              }
            })
          });
          // console.log('handleChildMessage:', data);
        }
      }
    },
    //修改排版样式
    typeSetting() {
      if (this.isDefaultType) {
        this.isDefaultType = false;
      } else {
        this.isDefaultType = true;
      }
    },
    submitYj() {
      //提交意见
      let _this = this;

      //1.商品id
      let goodsid = _this.baseinfo.id;
      //1.1评论内容
      let feedbackContent = _this.commentText;

      if (!feedbackContent) {
        _this.$message({
          message: '请输入建议内容',
          type: 'warning'
        });
        return;
      }

      //2.操作账号
      let userid_ = _this.$store.state.userId != null ? _this.$store.state.userId : '';
      if (!userid_) {
        _this
          .$confirm('请先登录账号再提交, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            _this.redirectLogin();
          })
          .catch(() => {
          });
        return;
      }
      //请求后台操作
      let paramdata = {};
      (paramdata.url = '/SJHG/logs/common/logscommon/saveLogsGoodsFeedback'),
        (paramdata.data = {
          goodsId: goodsid, //商品id
          feedbackContent: feedbackContent //商品id
        });

      //请求成功
      paramdata.onSuccess = function (res) {
        if (res.data.ok) {
          _this.$message({
            message: '提交建议成功！',
            type: 'success'
          });

          //情况录入值
          _this.commentText = '';
          //刷新意见列表
          _this.loadYj();
        }
      };
      _this.$axiosUtil.postServer(paramdata);
    },
    loadYj(pageParm) {
      //加载意见意见
      let _this = this;

      //1.商品id
      let goodsid = _this.baseinfo.id;

      //请求后台操作
      let paramdata = {};
      (paramdata.url = '/SJHG/logs/common/logscommon/loadLogsGoodsFeedbackByGoodsId'),
        (paramdata.data = {
          goodsId: goodsid //商品id
        });

      //----------------------添加分页参数
      paramdata.data.pageNo = _this.currentPage; //页码
      paramdata.data.pageSize = _this.pageSize; //每页数量
      //请求成功
      paramdata.onSuccess = function (res) {
        if (res.data.ok) {
          var data_ = res.data.result;
          _this.loadYjResult(data_);
        }
      };
      _this.$axiosUtil.postServer(paramdata);
    },
    //加载查询结果
    loadYjResult: function (result) {
      let this_ = this;
      let list = [];
      let pageNo = 1;
      let pageSize = 10;
      let count = 0;

      let page_ = result.page; //全部
      //判断有无查询结果
      if (page_.count === undefined || !page_.count || page_.count === null || page_.count === 'null' || page_.count === 0) {
      } else {
        list = page_.list;
        pageNo = page_.pageNo;
        pageSize = page_.pageSize;
        count = page_.count;
      }
      // this_.searchResult = list;
      this_.currentPage = pageNo;
      this_.pageSize = pageSize;
      this_.total = count;

      let commentList = [];
      list.forEach(item => {
        commentList.push({
          name: item.user.id,
          time: item.feedbackTime,
          commentText: item.feedbackContent,
          fabulous: '1',
          reply: []
        });
        // commentList.push({
        //   name:item.user.id,
        //   time:item.feedbackTime,
        //   commentText:item.feedbackContent,
        //   fabulous:'1',
        //   reply: [{
        //         replyNmae: '管理员',
        //         replayTime: '一周前',
        //         replayText: '谢谢支持！',
        //         fabulous: 0
        //       }]
        // });
      });
      this_.commentList = commentList;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadYj();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadYj();
    },
    handlePrevClick(val) {
      //上一页
      this.currentPage = val;
      this.loadYj();
    },
    handleNextClick(val) {
      //下一页
      this.currentPage = val;
      this.loadYj();
    },
    handleTabchange(tab, event) {

      //标签页点击事件
      let _this = this;
      let activeName = tab.name; //获取到当前元素的name
      if (activeName === undefined || activeName === null || activeName === '') return;
      if (activeName === 'four') {
        // console.log("点击我的建议",activeName);
        //您的建议
        _this.loadJy();
      } else if (activeName === 'five') {
        //评论
        _this.loadYj();
      } else if (activeName === 'one') {
        //切换商品橱窗  重新初始化图片滑动插件（防止滑动区域只显示一张图）
        this.swiperFlag = true;
        this.swiperInit();
      }
    },
    handleRateSelect(val) {
      //商品评分
      // console.log('商品评分:', val);
      let _this = this;

      //1.商品id
      let goodsid = _this.baseinfo.id;
      //2.操作账号
      let userid_ = _this.$store.state.userId != null ? _this.$store.state.userId : '';
      //收藏日志id
      let logId = _this.baseinfo.logsGoodsRateId;
      let mes_ = '';
      if (logId) {
        mes_ = '评星';
      } else {
        mes_ = '评星';
      }
      if (!userid_) {
        _this
          .$confirm('请先登录账号再' + mes_ + ', 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            _this.redirectLogin();
          })
          .catch(() => {
          });
        return;
      }

      //请求后台操作
      let paramdata = {};
      (paramdata.url = '/SJHG/logs/common/logscommon/saveLogsGoodsRate'),
        (paramdata.data = {
          goodsId: goodsid, //商品id
          logId: logId, //商品id
          rate: val //分值
        });
      //请求成功
      paramdata.onSuccess = function (res) {
        if (res.data.ok) {
          var data_ = res.data.result;
          if (logId) {
            _this.baseinfo.logsGoodsRateCount = Number(data_.count);
          } else {
            _this.baseinfo.logsGoodsRateId = data_.id;
            _this.baseinfo.logsGoodsRateCount = Number(data_.count);
          }
        }
      };
      _this.$axiosUtil.postServer(paramdata);
    },
    showBigPicture() {
      this.showPicture = true;
      this.pictuerSwiperInit();
    },
    pictuerSwiperInit() {
      var _this = this;
      this.$nextTick(() => {
        this.bigPictureSwiper = new Swiper('.swiper2', {
          initialSlide: this.mySwiper.realIndex,
          autoplay: false, //可选选项，自动滑动
          normalizeSlideIndex: false
          /* on: {
            click: function(event) {
              this.slideTo(this.clickedIndex);
              _this.imgChange(this.clickedIndex);
            },
          } */
        });
      });
    },
    pictureLeft() {
      this.bigPictureSwiper.slidePrev();
    },
    pictureRight() {
      this.bigPictureSwiper.slideNext();
    },
    //重定向登陆页
    redirectLogin() {
      //跳转登录页,且地址栏不显示原链接
      this.$router.push({
        name: 'userLogin',
        params: {
          redirect_url: this.$route.fullPath
        }
      });
      //跳转登录页,且地址栏显示原链接
      // this.$router.push({path:"/userLogin",query:{redirect_url:this.$route.fullPath}});
    },
    submitJy() {
      //提交建议
      let _this = this;

      //1.商品id
      let goodsid = _this.baseinfo.id;
      //1.1评论内容
      let suggestionContent = _this.suggestionText;

      if (!suggestionContent) {
        _this.$message({
          message: '请输入建议内容',
          type: 'warning'
        });
        return;
      }

      //2.操作账号
      let userid_ = _this.$store.state.userId != null ? _this.$store.state.userId : '';
      if (!userid_) {
        _this
          .$confirm('请先登录账号再提交, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            _this.redirectLogin();
          })
          .catch(() => {
          });
        return;
      }
      //请求后台操作
      let paramdata = {};
      (paramdata.url = '/SJHG/logs/common/logscommon/saveLogsGoodsSuggestion'),
        (paramdata.data = {
          goodsId: goodsid, //商品id
          suggestionContent: suggestionContent //建议内容
        });

      //请求成功
      paramdata.onSuccess = function (res) {
        if (res.data.ok) {
          _this.$message({
            message: '提交建议成功！',
            type: 'success'
          });

          //情况录入值
          _this.suggestionText = '';
          //刷新意见列表
          _this.loadJy();
        }
      };
      _this.$axiosUtil.postServer(paramdata);
    },
    loadJy(pageParm) {
      //加载建议
      let _this = this;

      //1.商品id
      let goodsid = _this.baseinfo.id;

      //请求后台操作
      let paramdata = {};
      (paramdata.url = '/SJHG/logs/common/logscommon/loadLogsGoodsSuggestion'),
        (paramdata.data = {
          goodsId: goodsid //商品id
        });

      //----------------------添加分页参数
      paramdata.data.pageNo = _this.scurrentPage; //页码
      paramdata.data.pageSize = _this.spageSize; //每页数量
      //请求成功
      paramdata.onSuccess = function (res) {
        if (res.data.ok) {
          var data_ = res.data.result;
          _this.loadJyResult(data_);
        }
      };
      _this.$axiosUtil.postServer(paramdata);
    },
    //加载建议查询结果
    loadJyResult: function (result) {
      let this_ = this;
      let list = [];
      let pageNo = 1;
      let pageSize = 10;
      let count = 0;

      let page_ = result.page; //全部
      //判断有无查询结果
      if (page_.count === undefined || !page_.count || page_.count === null || page_.count === 'null' || page_.count === 0) {
      } else {
        list = page_.list;
        pageNo = page_.pageNo;
        pageSize = page_.pageSize;
        count = page_.count;
      }
      this_.scurrentPage = pageNo;
      this_.spageSize = pageSize;
      this_.stotal = count;

      let suggestionList = [];
      list.forEach(item => {
        //建议列表
        suggestionList.push({
          id: item.id,
          name: item.user.name,
          time: item.suggestionTime,
          commentText: item.suggestionContent,
          photo: item.user.photo,
          relplyTotal: item.replyTotal,
          fabulous: '1',
          showHF: false, //默认隐藏回复
          reply: []
        });
      });
      this_.suggestionList = suggestionList;
    },
    handleSizeChanges(val) {
      this.spageSize = val;
      this.loadJy();
    },
    handleCurrentChanges(val) {
      this.scurrentPage = val;
      this.loadJy();
    },
    handlePrevClicks(val) {
      //上一页
      this.scurrentPage = val;
      this.loadJy();
    },
    handleNextClicks(val) {
      //下一页
      this.scurrentPage = val;
      this.loadJy();
    },
    loadJyHF(item_) {
      //加载建议回复
      if (item_.showHF) {
        //隐藏回复
        item_.showHF = false;
      } else {
        //显示回复
        item_.showHF = true;
      }

      let _this = this;
      //请求后台操作
      let paramdata = {};
      (paramdata.url = '/SJHG/logs/common/logscommon/loadLogsGoodsSuggestion4Reply'),
        (paramdata.data = {
          suggestionId: item_.id //建议id
        });

      //----------------------添加分页参数
      paramdata.data.pageNo = _this.scurrentPage; //页码
      paramdata.data.pageSize = _this.spageSize; //每页数量
      //请求成功
      paramdata.onSuccess = function (res) {
        if (res.data.ok) {
          let page_ = res.data.result.page; //全部
          let list = page_.list;
          //遍历更新建议列表回复
          _this.suggestionList.forEach(items => {
            if (items.id === item_.id) {
              //回复人
              var replys = [];
              list.forEach(item => {
                replys.push({
                  name: item.user.name,
                  time: item.suggestionTime,
                  commentText: item.suggestionContent,
                  photo: item.user.photo
                });
              });
              _this.$set(items, 'reply', replys);
            }
          });
        }
      };
      _this.$axiosUtil.postServer(paramdata);
    },
    loadJyDetail(suggestionid, replyid) {
      //精确加载建议及回复
      let _this = this;
      //请求后台操作
      let paramdata = {};
      (paramdata.url = '/SJHG/logs/common/logscommon/loadLogsGoodsSuggestion4Detail'),
        (paramdata.data = {
          suggestionId: suggestionid //建议id
        });
      //请求成功
      paramdata.onSuccess = function (res) {
        if (res.data.ok) {
          let suggestion = res.data.result.suggestion;
          let replylist = res.data.result.replylist;

          //回复数组
          var replys = [];
          replylist.forEach(item => {
            replys.push({
              name: item.user.name,
              time: item.suggestionTime,
              commentText: item.suggestionContent,
              photo: item.user.photo,
              focus: replyid == item.id ? true : false
            });
          });

          //建议
          let suggestionList = [];
          //建议列表
          suggestionList.push({
            id: suggestion.id,
            name: suggestion.user.name,
            time: suggestion.suggestionTime,
            commentText: suggestion.suggestionContent,
            photo: suggestion.user.photo,
            relplyTotal: suggestion.replyTotal,
            fabulous: '1',
            showHF: true, //默认显示回复
            reply: replys
          });
          _this.suggestionList = suggestionList;
          _this.scurrentPage = 1;
          _this.spageSize = 10;
          _this.stotal = 1;
        }
      };
      _this.$axiosUtil.postServer(paramdata);
    },

    //切换天算知识并为切换的知识添加引用值
    changeActiveTSTab(id) {
      this.activeTSTab = id;

      //更新选中知识的引用参数值
      this.knowledgeToolsStepList.forEach(step => {
        if (step.knowledgeId == id) {
          step.knowledgeToolsDetailAll.forEach(item => {
            if (item.type == 'PARAM') {
              if (item.dataSource == 'QUOTE_FORMULA_PARAM') {
                //引用知识id
                let dataQuote = item.dataQuote;
                //引用知识中的符号
                let dataQuoteCode = item.dataQuoteCode;
                let dataQuoteCodeValue = '';
                //获取引用知识符号的值
                let dataQuoteKnowledgeToolsStep = this.knowledgeToolsStepList.filter(item => item.knowledgeId == dataQuote)[0];
                if (dataQuoteKnowledgeToolsStep) {
                  let dataQuoteKnowledgeToolsDetail = dataQuoteKnowledgeToolsStep.knowledgeToolsDetailAll.filter(item => item.code == dataQuoteCode)[0];
                  if (dataQuoteKnowledgeToolsDetail) {
                    dataQuoteCodeValue = dataQuoteKnowledgeToolsDetail.codevalue;
                  }
                }
                this.$set(item, 'codevalue', dataQuoteCodeValue);
              }
            }
          });
        }
      });
    },
    //天算表格列合并
    columnSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (row.type === 'TITLE') {
        //标题参数行  列合并
        if (columnIndex === 2) {
          //column.showOverflowTooltip = false;
          return [1, 5];
        } else if (columnIndex === 0) {
          return [1, 1];
        } else {
          return [0, 0];
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#algorithmDetail {}

// 修改输入框字体颜色 在这里修改
.my-input>>>.el-input__inner {
  color: #19ac38;
}

.el-table .showRow {
  display: none !important;
}

.content {
  // width: 1280px;
  width: 100%;
  margin: 0 auto;
  padding-bottom: 20px;
}

.widthStyle {
  width: 60%; // 修改 2023年10月26日13:42:58
  margin: 0 auto;
  margin-bottom: 100px;
}

.widthStyle-w80 {
  // width: 80%;
  width: 80%; // 修改 2023年10月26日13:42:58
  height: 100%;
  margin: 0 auto;
  margin-bottom: 100px;
}

.crumbs {
  background: $color-primary;
}

.crumbs>.el-breadcrumb__inner {
  color: #fff;
}

.crumbs>.el-icon-arrow-right {
  color: #fff;
}

.tableBox {
  margin-top: 30px;
}

.tableBox>.el-tabs__item {
  font-size: 18px;
  color: #736a66;
}

.tableBox>.el-tabs--border-card>.el-tabs__header {
  background: #f2f2f2;
}

.tableBox>.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
  color: #fff;
  background-color: $color-primary;
  border-color: $color-primary;
}

.tableBox>.el-input__inner {
  height: 30px;
  line-height: 30px;
}

.tableBox>.el-input.is-disabled .el-input__inner {
  color: red;
}

.container-table {
  width: 99%;
  margin: 20px auto 0;
}

.textStyle {
  color: #ff0000;
}

.bottomBtn {
  display: inline-block;
  padding: 8px 30px;
  margin: 20px;
  background: $color-primary;
  color: #fff;
  font-size: 16px;
  border-radius: 4px;
  border: 1px solid $color-primary;
  cursor: pointer;
}

.bottomBtn-clear {
  display: inline-block;
  padding: 8px 30px;
  margin: 20px;
  //background: $color-primary;
  color: #f54842;
  font-size: 16px;
  border-radius: 4px;
  border: 1px solid $color-primary;
  cursor: pointer;
}

.bottomBtn:hover {
  background: #f54842;
}

.bottomBtnDisabled {
  display: inline-block;
  padding: 8px 30px;
  margin: 20px;
  background: #999;
  color: #fff;
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;
}

/* 免费试用框的样式 start*/
.freeTrial {
  position: absolute;
  right: 0;
  bottom: 0;
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  border: 1px solid #ff9900;
}

.freeTrial>div {
  display: inline-block;
  float: left;
}

.freeTrial>div:first-child {
  background: #fbfbfb;
  color: #f9b248;
  padding: 0 3px;
}

.freeTrial>div:nth-child(2) {
  width: 0;
  height: 0;
  border-bottom: 32px solid #ff9900;
  border-left: 16px solid transparent;
}

.freeTrial>div:nth-child(3) {
  color: #fff;
  background: #ff9900;
  padding: 0 3px;
}

.freeTrial>div:nth-child(3) span {
  font-size: 16px;
}

//.freeTrial .repurchase{
//  cursor: pointer;
//}

/* end */
.flexRow {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.flexRowBetween {
  justify-content: space-between;
}

.align {
  align-items: center;
}

.title {
  line-height: 16px;
  padding-left: 4px;
  border-left: 2px solid $color-primary;
}

.width45 {
  width: 45%;
}

.width48 {
  width: 48%;
}

.lines {
  width: 200px;
  height: 1px;
  background: #f2f2f2;
  margin: 5px 0 10px;
}

.fn14Sty {
  width: 33%;
  font-size: 14px;
}

.inputBox {
  width: 60%;
}

.msg>div {
  margin-bottom: 10px;
}

.msg>.el-input__inner {
  padding: 0;
}

.margin20 {
  margin-bottom: 20px;
}

.rows {
  margin-bottom: 10px;
}

.rowLeft {
  width: 50%;
}

.rowRight {
  width: 33%;
}

.fn14 {
  font-size: 14px;
}

.fn15 {
  font-size: 15px;
}

.padding0 .el-input__inner {
  color: #67C23A;
}

.tableRrows {
  display: flex;
}

.tableRrows>div {
  box-sizing: border-box;
  border: 1px solid #ebeef5;
  //border-bottom: none;
  padding: 12px 10px;
}

.tableRrows>div:first-child {
  width: 70%;
  // width: 15%; // 修改 2023年10月26日14:05:06
}

.tableRrows>div:nth-child(2) {
  width: 30%;
  // width: 15%; // 修改 2023年10月26日14:09:08

}

.titleStyle {
  width: 100% !important;
  color: #fff;
  font-weight: bold;
  background: #f66f6a; // 修改 2023年10月26日14:17:49
}

.borderRightNone {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  // justify-content: center;
  border-right: none !important;
}

.customTable .tableRrows:not(:last-child)>div {
  border-bottom: none;
}

.customTable>div:not(:last-child) .tableRrows>div {
  border-bottom: none;
}

.tableRrowsFn14 {
  font-size: 14px;
  color: rgb(96, 98, 102);
}

.tableRrowsFn12 {
  font-size: 12px;
  color: #3f3f3f;
}

.hoverStyle:hover {
  background: #f5f7fa;
}

/* 知识橱窗start */
.displayWindow {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 30px;
}

.displayWindow>div {
  border: 1px solid $color-primary;
}

.displayWindow-left {
  width: 30%;
}

.imgBox {
  width: 100%;
  // height: 50vh;
  max-height: 50vh;
  padding: 5px;
  box-sizing: border-box;
  overflow: hidden;

}



.displayWindow-left>img {
  height: 100%;
  width: 100%;
}

.displayWindow-middle {
  width: 43%;
  position: relative;
}

.displayWindow-right {
  width: 25%;
  padding: 10px;
  box-sizing: border-box;
}

.swiperContent {
  display: flex;
  // flex-direction: row;
  align-items: center;
}

.swiper-slide {
  width: 100% !important;
  border: 1px solid #fff;
  height: 70px;
  box-sizing: border-box;
}

.swiper-slide-active {
  border: 1px solid $color-primary;
}

.swiper-slide img {
  width: 100%;
  height: 100%;
  justify-content: space-between;
  object-fit: fill;
  cursor: pointer;
}

.rightIcon,
.leftIcon {
  cursor: pointer;
}

.rightIcon i,
.leftIcon i {
  color: $color-primary;
}

.left-bottom {
  padding: 0 16px;
  font-size: 14px;
  margin-top: 10px;
}

.mar10 {
  margin-bottom: 10px;
}

.middleTitle {
  width: 70%;
  margin: 10px auto;
  text-align: center;
  color: $color-primary;
  font-size: 18px;
  font-weight: 550;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.jianjie {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
  text-indent: 28px;
}

.mulu {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-indent: 28px;
}

.leixing {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-indent: 28px;
}

.introduction {
  padding: 10px;
}

.introduction .rowdiv {
  margin: 5px 0px 8px 0px;
}

.displayWindow-middle .freeTrial {
  right: inherit;
  border: 1px solid #ff9900;
  right: 0;
}

.priceStyle {
  font-size: 14px;
  text-decoration: underline;
}

.priceStyleThrough {
  font-size: 14px;
  text-decoration: line-through;
}

.btnStyle {
  margin: auto;
  padding: 8px 16px;
  font-size: 18px;
  color: #fff;
  background: $color-primary;
  border: 1px solid $color-primary;
  font-weight: 600;
  cursor: pointer;
}

.btnStyle:hover {
  background: #f54842;
}

.btnStyleactive {
  margin: auto;
  padding: 8px 16px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  color: #fff;
  background: $color-primary;
}

.borderRight {
  padding-left: 4px;
  border-left: 2px solid $color-primary;
  line-height: 16px;
  margin-bottom: 10px;
}

.labelStyle {
  margin-bottom: 5px;
}

.labelStyle>span {
  display: inline-block;
  padding: 2px;
  border: 1px solid $color-primary;
  color: $color-primary;
  font-size: 14px;
}

.relationLeft {
  width: 75%;
  color: #666;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.relationRight {
  width: 25%;
  color: $color-primary;
  text-align: right;
}

/* 知识橱窗end */

/* 参考资料start */
.tabPaneIntroduction {
  width: 450px;
}

.tabPanejianjie {
  text-indent: 28px;
}

/* 参考资料end */

/* 评论start */
.comment {
  width: 80%;
  margin: 0 auto;
}

.fn14Sty1 {
  font-size: 14px;
  color: #ccc;
}

.commentContent {
  width: 600px;
}

.commentImage {
  width: 42px;
  height: 42px;
  margin-right: 20px;
}

.flex1 {
  flex: 1;
}

.submitBtn {
  overflow: hidden;
  padding: 20px 0;
}

.submitBtn>span {
  background: #ff9900;
  padding: 6px 14px;
  color: #fff;
  font-size: 14px;
  float: right;
  border-radius: 4px;
  cursor: pointer;
}

.fn14Sty2 {
  font-size: 14px;
  color: #999;
}

.yizan {
  color: #bfbfbf;
}

.commentText {
  color: #666;
  padding: 10px 0;
}

.commentText .focus {
  color: #c75a5a;
}

.marBottom {
  margin-bottom: 10px;
}

.comment>.el-pager li.active {
  color: $color-primary;
}

.comment>.el-pager li:hover {
  color: $color-primary;
}

.magnifier-box>img {
  width: 100% !important;
  height: 100% !important;
}

/* 评论end */
.color1 {
  color: #747474;
}

.guanzhu {
  color: $color-primary;
}

.hoverClass:hover {
  cursor: pointer;
}

.hoverClass:hover .color1 {
  color: $color-primary;
}

/* 控制对话框中异常堆栽信息隐藏 */
>.all .main {
  padding: 0;
  margin-left: 0;
}

>.all .main .btn {
  display: none;
}

>.all .main .font2 {
  display: none;
}

.changeType {
  cursor: pointer;
  background: rgb(16, 141, 233);
  color: #fff;
  position: absolute;
  right: 1px;
  top: 0px;
  height: 32px;
  line-height: 32px;
  padding: 0px 8px;
  font-size: 12px;
}

.widthStyle .el-tabs__content {
  overflow: visible;
}

.two-tabs {
  position: absolute;
  left: -130px;
  top: 0;
  background-color: #f2f2f2;
  font-size: 14px;
  // z-index: 999;
}

.two-tabs p {
  cursor: pointer;
  transition: all 0.3s;
  padding: 0 20px;
  width: 130px;
  height: 40px;
  line-height: 40px;
  margin: 0;
  text-align: center;
  box-sizing: border-box;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.two-tabs .activeTSTab {
  background-color: #f66f6a;
  color: #fff;
  transition: all 0.3s;
}

.two-tabs .activeTSTab:hover {
  color: #fff;
}

.two-tabs p:hover {
  color: #f66f6a;
}

.flexRow {
  display: flex;
  flex-direction: row;
}

.flex1 {
  flex: 1;
  overflow: hidden;
}

.directionLeft,
.directionRight {
  display: flex;
  flex-direction: row;
  align-items: center;
  color: $color-primary;
}

.directionLeft {
  padding-right: 20px;

  i {
    cursor: pointer;
  }
}

.directionRight {
  padding-left: 20px;

  i {
    cursor: pointer;
  }
}

.bigPicture .swiper-slide-active {
  border: none;
}

.swiper2 .swiper-slide {
  height: 500px;

  img {
    width: 100%;
    height: 100%;
  }

  .el-image {
    height: 100%;
    width: 100%;
  }
}

.errorBox .flexRow {
  align-items: self-start;
  margin-bottom: 20px;
}

.errorButton {
  padding: 6px 12px;
  background: #71a4b5;
  margin-right: 10px;
  color: #fff;
  border-radius: 4px;
}

.errorText {
  color: #777777;
}

.errorBox p {
  margin: 0 0 10px;
}

>.el-dialog__header {
  text-align: center;
}

.tableBox>.el-select {
  width: 100%;
}

.fn14weight {
  font-size: 14px;
  font-weight: 600;
}

.color777 {
  color: #777;
}

.btnabsolute {
  width: 100%;
  background: #fff;
  box-sizing: border-box;
  position: absolute;
  left: 0;
  bottom: 10px;
}

.mar15 {
  margin-bottom: 15px;
}

.userPhoto {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 5px;
}

.content>.el-input__suffix {
  height: 30px;
}

.content>.el-input__icon {
  line-height: 30px;
}

.secondForm {
  border: 1px solid #ebeef5;
  border-bottom: none;
  border-radius: 0;
  // width: 25%;
  width: 30%; // 修改 2023年10月26日14:08:07
  box-sizing: border-box;
  padding: 12px 10px;
}

.el-form-item {
  margin: 0;
}

/************** 修改 新增样式 2023年10月26日14:29:21 ****************/

.tuwen-table-container {
  // min-height: 80vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: auto;
}


.table-container {
  min-height: 80vh;
  width: 58%;
  display: flex;
  flex-direction: column;
}

/* 图文排版 右侧图纸显示区域 */
.image-show-container {
  width: 42%;
  display: flex;
  position: relative;
  // border: 1px solid #666;
  align-items: flex-start;
  justify-content: center;
}

.dict-data-style {
  margin: auto;
  height: 100%;
  width: 70%;
}

.image_show-box {
  max-height: 80vh;
  position: fixed;
  top: 0;
}

.pagination-container {
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.customTable-style {
  display: flex;
  width: 100%;
  justify-content: space-between;
  // flex-direction: column;
}

/* 天算提交按钮容器 */
.ts-commit-btn-box {
  z-index: 99;
  width: 100vw;
  position: fixed;
  bottom: 0;
  left: 0;
  background: #fff;
  box-shadow: -1px -1px 10px rgba(0, 0, 0, 0.2);
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/toolKnowledgeDetails.vue